import {gql} from '@apollo/client';

const UPDATE_COUNTRY_DRIVER_COST = gql`
  mutation updateCountryDriverCostEntry(
    $countryId: ID!
    $year: Int!
    $accommodationCostPerNight: Float
    $dailyAllowance: Float
    $daytimeWeekdaysWorkingHourCost: Float
    $daytimeWeekendsWorkingHourCost: Float
    $nighttimeWeekdaysWorkingHourCost: Float
    $nighttimeWeekendsWorkingHourCost: Float
    $prefilledEmptyDistance: Distance
    $prefilledEmptyHr: Float
    $replacementCostPerHr: Float
    $replacementCostPerKm: CostPerDistance
  ) {
    updateCountryDriverCostEntry(
      input: {
        countryId: $countryId
        year: $year
        accommodationCostPerNight: $accommodationCostPerNight
        dailyAllowance: $dailyAllowance
        daytimeWeekdaysWorkingHourCost: $daytimeWeekdaysWorkingHourCost
        daytimeWeekendsWorkingHourCost: $daytimeWeekendsWorkingHourCost
        nighttimeWeekdaysWorkingHourCost: $nighttimeWeekdaysWorkingHourCost
        nighttimeWeekendsWorkingHourCost: $nighttimeWeekendsWorkingHourCost
        prefilledEmptyDistance: $prefilledEmptyDistance
        prefilledEmptyHr: $prefilledEmptyHr
        replacementCostPerHr: $replacementCostPerHr
        replacementCostPerKm: $replacementCostPerKm
      }
    ) {
      accommodationCostPerNight
      currency
      dailyAllowance
      daytimeWeekdaysWorkingHourCost
      daytimeWeekendsWorkingHourCost
      nighttimeWeekdaysWorkingHourCost
      nighttimeWeekendsWorkingHourCost
      prefilledEmptyDistance
      prefilledEmptyHr
      replacementCostPerHr
      replacementCostPerKm
      year
    }
  }
`;

export default UPDATE_COUNTRY_DRIVER_COST;
